import axios from 'axios';
import { API_ROOT, TIFOXR_ACTIVE_SPACE_KEY } from './apiConfig';

export const getSpaceId = () => {
  try {
    const raw = localStorage.getItem(TIFOXR_ACTIVE_SPACE_KEY);
    const id = raw ? JSON.parse(raw).spaceId : null;
    const num = Number(id);
    return Number.isInteger(num) && num > 0 ? num : null;
  } catch {
    return null;
  }
};

const spaceUrl = (path) => `${API_ROOT}/${getSpaceId()}${path}`;

export const spaceClient = {
  get:    (path, config)       => axios.get(spaceUrl(path), config),
  post:   (path, data, config) => axios.post(spaceUrl(path), data, config),
  put:    (path, data, config) => axios.put(spaceUrl(path), data, config),
  patch:  (path, data, config) => axios.patch(spaceUrl(path), data, config),
  delete: (path, config)       => axios.delete(spaceUrl(path), config),
};

// Read-only client bound to an explicit spaceId, without touching the active-space in localStorage.
export const spaceClientFor = (spaceId) => ({
  get: (path, config) => axios.get(`${API_ROOT}/${spaceId}${path}`, config),
});
